import * as ROUTES from 'src/constants/Routes'
import React from 'react'
import { format } from '@flatsy/utils/Functions/DateTime/Datefns'
import { generatePath, useHistory, useParams } from 'react-router'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import { Body1, Header1, SubBody2 } from '@flatsy/core/MaterialUi/Typo'
import theme from '@flatsy/core/MuiTheme/theme'
import { useApplicationDetails } from 'src/hooks/ApplicationDetails'
import { Body2 } from '@flatsy/core/MaterialUi/Typo'
import { toNameCase } from '@flatsy/core/MaterialUi/Typo/Utile'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import clsx from 'clsx'
import { InfoOutlined } from '@material-ui/icons'
import { parseApiDate } from '@flatsy/utils/Functions/DateTime/Date'
import { Avatar, Button } from '@material-ui/core'
import { formatPhoneNumber } from '@flatsy/utils/Functions/format/PhoneNumber'
import { LayoutCards } from '@flatsy/core/Layout/Cards'
import { useStyles } from '../Style'
import { useStyle } from './Style'

const NewReschedule: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  const classesReschedule = useStyle()
  const { applicationId } = useParams<{ applicationId: string }>()
  const {
    application: { application },
    asset,
  } = useApplicationDetails()
  const history = useHistory()
  const oldbooking = application && application.bookings && application.bookings[1]
  const booking = application && application.bookings && application.bookings[0]

  const handleConfirmReschedule = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault()
    history.push(
      generatePath(ROUTES.APPLICATION_BOOKING, {
        applicationId,
      })
    )
  }

  const renderBookingDate = () => {
    return (
      booking &&
      booking.start_date &&
      booking.start_time &&
      toNameCase(
        format(
          parseApiDate(`${booking.start_date}T${booking.start_time}`),
          "eeee dd MMMM yyyy à H'h'mm"
        )
      )
    )
  }

  return (
    <LayoutCards className={classesReschedule.layoutCards}>
      <Header1
        fontColor={theme.palette.primary.dark}
        className={classes.bookingHeaderTitle}
        align="center"
        lowerCase
      >
        Votre créneau de visite change
      </Header1>
      {asset && asset.instructions && (
        <div className={classes.instruction}>
          <ReportProblemOutlinedIcon className={classes.iconInstruction} />
          <Body2>{asset.instructions}</Body2>
        </div>
      )}
      <Body2 fontColor={theme.palette.secondary.dark} className={classes.agent}>
        Ce créneau est choisi et préféré par votre agent
        {booking && (
          <>
            <Avatar
              alt={`${booking.agent.first_name} ${booking.agent.last_name}`}
              src={booking.agent.picture_url}
              className={classes.avatar}
            />
            <Body1>{booking?.agent?.first_name}</Body1>
          </>
        )}
      </Body2>
      <div className={classesReschedule.dividerTop} />
      <div className={classesReschedule.container}>
        <div className={classesReschedule.newDate}>
          <EventAvailableIcon className={classesReschedule.iconEvent} />
          <div>
            <Header1 lowerCase align="center" className={classes.bookingTitle}>
              {renderBookingDate()}
            </Header1>
            <SubBody2>Votre nouvel horaire</SubBody2>
          </div>
        </div>
        <div className={classesReschedule.oldDate}>
          <SubBody2 className={classesReschedule.textOldDate}>Votre ancien horaire :</SubBody2>
          <SubBody2 className={classesReschedule.dateOldDate}>
            {oldbooking &&
              toNameCase(
                format(
                  parseApiDate(`${oldbooking.start_date}T${oldbooking.start_time}`),
                  "eeee dd MMMM yyyy à H'h'mm"
                )
              )}
          </SubBody2>
        </div>
      </div>
      <div className={classesReschedule.dividerBottom} />
      <div className={classes.containerButton}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleConfirmReschedule}
          disableElevation
          className={classes.button}
        >
          Continuer
        </Button>
      </div>
      <div className={clsx(classes.instruction, classes.instructionTop)}>
        <InfoOutlined className={classes.iconInstruction} />
        <span className={classes.contactAgent}>
          Si ce créneau ne vous convient pas, contactez
          <span className={classes.bold}>{booking && booking.agent.first_name}</span>
          au
          <span className={classes.bold}>
            {booking && formatPhoneNumber(booking.agent.phone_number)}
          </span>
          pour modifier celui-ci
        </span>
      </div>
    </LayoutCards>
  )
}

export default NewReschedule
